const URL_SCHEME_REGEX = /^[a-z][a-z\d+\-.]*:/i;

/**
 * Returns true if the URL uses any protocol scheme (http, https, mailto, tel, ftp, etc.)
 * or is protocol-relative (starts with //). These URLs should be handled by the browser
 * natively rather than passed to an internal smart link resolver.
 */
export function isExternalUrl(url: string): boolean {
  return url.startsWith('//') || URL_SCHEME_REGEX.test(url);
}
